var map = {
	"./goods-mobile-1.png": "1693",
	"./goods-mobile-2.png": "0dd8",
	"./goods-mobile-3.png": "ea5a",
	"./goods-mobile-4.png": "cb61",
	"./goods-mobile-5.png": "9fa8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1a42";